import styled, {css} from 'styled-components';


export const ContainerWrapper = styled.div<{noBackgroundColor: boolean, backgroundColor: string}>`
  display: flex;
  padding: ${props => props.noBackgroundColor ? '16px 16px' : '0 16px'}

  background-color: ${props=>handleBackgroundColor(props.backgroundColor)};

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: ${props => props.noBackgroundColor ? '20px 36px' : '4px 36px'}
  }
  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
    padding: ${props => props.noBackgroundColor ? '24px 36px' : '8px 36px'}
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  
  @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    flex-direction: column;
  } 
`;

export const StyledColumn = styled.div<{ colCount: number, backgroundColor: string }>`
  flex: 1;
  padding-left: 16px;
  padding-right: 16px;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
    padding-left: 32px;
    padding-right: 32px;
  }

  ${props => props.colCount === 1 && css`
    max-width: 824px;
  `}

  ${props => props.backgroundColor !== 'default' && css`
    padding-top: 16px;
    padding-bottom: 16px;
  `}

`;

const handleBackgroundColor = (color: string) => {
  let backgroundColor = color ? color : 'default';
  switch (backgroundColor.toLowerCase()) {
    case 'secondary':
      return '#F7F7FB';
    case 'custom':
    case 'default':
    default:
      return '';
  }
};